import ConnectPermissionsRoute from 'garaje/pods/location-settings/connect-permissions/route';

export default class ManageConnectPermissionsRoute extends ConnectPermissionsRoute {
  controllerName = 'location-settings/connect-permissions';
  templateName = 'location-settings/connect-permissions';
  connectRoute = 'manage.location-settings.index.connect';
  connectPermissionsRoute = 'manage.location-settings.connect-permissions';
}
